import { Controller } from "@hotwired/stimulus"

// Progress tracker controller pour barre de progression sticky des formulaires multi-�tapes
// Utilise Intersection Observer pour d�tecter automatiquement la section visible
// Usage:
//   <div data-controller="progress-tracker">
//     <div data-progress-tracker-target="step1Badge">1</div>
//     <div data-progress-tracker-target="progress1"></div>
//     ...
//     <div data-progress-tracker-target="section" data-step="1">Section 1</div>
//     <div data-progress-tracker-target="section" data-step="2">Section 2</div>
//   </div>
export default class extends Controller {
  static targets = [
    "section",
    "step1Badge", "step2Badge", "step3Badge",
    "progress1", "progress2",
    "container"
  ]

  connect() {
    this.currentStep = 1
    this.setupIntersectionObserver()
    this.setupScrollListener()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener('scroll', this.handleScroll)
  }

  setupScrollListener() {
    this.handleScroll = () => {
      if (window.scrollY > 100) {
        this.containerTarget.classList.add('scrolled', 'shadow-lg')
      } else {
        this.containerTarget.classList.remove('scrolled', 'shadow-lg')
      }
    }

    window.addEventListener('scroll', this.handleScroll)
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "-50% 0px -50% 0px", // Trigger quand la section est au milieu de l'�cran
      threshold: 0
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const step = parseInt(entry.target.dataset.step)
          this.updateProgress(step)
        }
      })
    }, options)

    // Observer toutes les sections
    this.sectionTargets.forEach(section => {
      this.observer.observe(section)
    })
  }

  updateProgress(step) {
    if (step === this.currentStep) return

    this.currentStep = step

    // Mettre � jour les badges des �tapes
    this.updateStepBadge(1, step >= 1)
    this.updateStepBadge(2, step >= 2)
    this.updateStepBadge(3, step >= 3)

    // Mettre � jour les barres de progression
    this.updateProgressBar(1, step >= 2)
    this.updateProgressBar(2, step >= 3)
  }

  updateStepBadge(stepNumber, isActive) {
    const badge = this[`step${stepNumber}BadgeTarget`]
    const stepContainer = badge.parentElement

    if (isActive) {
      // Étape active ou complétée
      badge.classList.remove('bg-gray-300', 'text-gray-600', 'scale-100')
      badge.classList.add('bg-blue-600', 'text-white', 'shadow-lg', 'scale-110')

      // Label actif
      const label = stepContainer.querySelector('span')
      if (label) {
        label.classList.remove('text-gray-500')
        label.classList.add('text-blue-700', 'font-semibold')
      }

      // Animation ring sur l'étape courante uniquement
      if (stepNumber === this.currentStep) {
        badge.classList.add('ring-4', 'ring-blue-300', 'ring-opacity-50')
        setTimeout(() => {
          badge.classList.remove('ring-4', 'ring-blue-300', 'ring-opacity-50')
        }, 1000)
      }
    } else {
      // Étape pas encore atteinte
      badge.classList.remove('bg-blue-600', 'text-white', 'shadow-lg', 'scale-110', 'ring-4', 'ring-blue-300', 'ring-opacity-50')
      badge.classList.add('bg-gray-300', 'text-gray-600', 'scale-100')

      // Label inactif
      const label = stepContainer.querySelector('span')
      if (label) {
        label.classList.remove('text-blue-700', 'font-semibold')
        label.classList.add('text-gray-500')
      }
    }
  }

  updateProgressBar(barNumber, isComplete) {
    const progressBar = this[`progress${barNumber}Target`]

    if (isComplete) {
      progressBar.classList.remove('bg-gray-300')
      progressBar.classList.add('bg-gradient-to-r', 'from-blue-500', 'to-blue-600')
    } else {
      progressBar.classList.remove('bg-gradient-to-r', 'from-blue-500', 'to-blue-600')
      progressBar.classList.add('bg-gray-300')
    }
  }
}
